import { render, staticRenderFns } from "./SharedJournalHome.vue?vue&type=template&id=e9eef72e&scoped=true"
import script from "./SharedJournalHome.vue?vue&type=script&lang=js"
export * from "./SharedJournalHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9eef72e",
  null
  
)

export default component.exports